import allImgPaths from 'assets/images';
import { InputTextField } from 'components/InputField'
import { cloneDeep } from 'lodash';
import React, { useEffect, useState } from 'react'
import RfpDrag from './RfpDrag';

const initLinks: any = [
    { title: 'X', value: '', class: 'x-title-icon' },
    { title: 'Facebook', value: '', class: 'facebook-title-icon' },
    { title: 'Instagram', value: '', class: 'instagram-title-icon' },
    { title: 'LinkedIn', value: '', class: 'linkedin-title-icon' },
    { title: 'Website', value: '', class: 'website-title-icon' }
]

const RfpSocialLinks = ({ data: dataObj, index, setItemData, removeItem, dragItem }: any) => {
    const [isChecked, setIsChecked] = useState(false);

    const [items, setItems] = useState(initLinks)

    useEffect(() => {
        if (dataObj?.updatedTime) {
            setItems(dataObj.content)
        }
    }, [dataObj?.updatedTime])

    const handleInputChange = (itemIndex: any, value: any) => {
        const clonedItems = cloneDeep(items)
        clonedItems[itemIndex]['value'] = value;
        setItems(clonedItems)
        setItemData({ index, content: clonedItems, showLabel: isChecked })
    };

    const handleCheckboxChange = (isChecked: boolean) => {
        setIsChecked(isChecked);
        setItemData({ index, content: items, showLabel: isChecked })
    };

    const remove = () => {
        removeItem({ index })
    }

    const drag = (position: string) => {
        dragItem({ index, position })
    }

    const removeInput = (inputIndex: number) => {
        const _filtered = cloneDeep(items).filter((_: any, i: number) => i != inputIndex)
        setItems(_filtered);

        if (_filtered?.length == 0) {
            remove()
        }
    }

    return (
        <>
            <div className="border border-[#F0F0F0] bg-[#F9F9F9] rounded-sm flex mb-6">

                {/* Drag */}
                <RfpDrag dragItem={drag} />

                {/* Content */}
                <div className="w-full my-2 mr-2 px-6 bg-white pt-5">
                    {/* <div className="mb-2 flex justify-between items-center px-0.5">
                        <span className='font-interMedium text-sm text-[#344054]'></span>
                        <div className='rfp-custom-checkbox'>
                            <input
                                type='checkbox'
                                name={'rfpName'}
                                checked={isChecked || false}
                                onChange={(e) => handleCheckboxChange(e.target.checked)}
                                style={{ width: '16px', height: '18px', cursor: 'pointer' }}
                            />
                            <label
                                className={`font-interMedium`}
                            >
                                <span className={`custom-checkbox-label font-interRegular text-sm text-[#667085] pl-1.5`}>Show label in draft</span>
                            </label>
                        </div>
                    </div> */}

                    {
                        items?.length > 0 && items.map((elem: any, index: number) => (
                            <div className="mb-6" key={index}>
                                <p className="text-[#344054] text-sm font-interMedium pb-1.5">
                                    {elem.title}
                                </p>
                                <div className="relative group">
                                    <div className="">
                                        <InputTextField
                                            className={`placeholder:text-[#D0D5DD] placeholder:text-base text-base text-[#344054] w-full !py-2 ${elem.class} !pl-11 !pr-10`}
                                            name={elem.title}
                                            placeholder={"Enter Handle"}
                                            onChange={(e: any) => handleInputChange(index, e?.target.value)}
                                            value={elem.value}
                                        />
                                        <img className='cursor-pointer hidden group-hover:block absolute top-3 right-4 hover:bg-[#FEE4E2] rounded w-5 p-1' src={allImgPaths.closeIconRed} alt="" onClick={() => removeInput(index)} />
                                    </div>
                                </div>
                            </div>
                        ))
                    }

                </div>
            </div>
        </>
    )
}

export default RfpSocialLinks